var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPageNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1034_82469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 183H19.5M400 183H144M144 183L162.27 203M144 183H124M313 368L273.719 325M162.27 203H400M162.27 203L179.627 222M179.627 222H397.5M179.627 222L198.811 243M198.811 243H395M198.811 243L217.081 263M217.081 263H387M217.081 263L235.351 283M235.351 283H379M235.351 283L255.449 305M255.449 305H369M255.449 305L273.719 325M273.719 325H355M124 183L280 386M124 183H102M102 183L235.351 401M102 183H81M81 183L179.627 401M81 183H60M60 183L124 386M60 183H39M39 183L65 351M39 183H19.5M19.5 183V283",
    stroke: "#8896AB",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 91.75C75 108.042 88.2076 121.25 104.5 121.25C92 99.5 95.5 83 104.5 62.25C88.2076 62.25 75 75.4576 75 91.75Z",
    stroke: "#8896AB",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.85,
    cy: 44.7054,
    r: 4.75,
    transform: "rotate(10.4316 190.85 44.7054)",
    fill: "#8896AB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.798,
    cy: 25.4476,
    r: 4.75,
    transform: "rotate(10.4316 218.798 25.4476)",
    fill: "#8896AB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250.269,
    cy: 31.2415,
    r: 4.75,
    transform: "rotate(10.4316 250.269 31.2415)",
    fill: "#8896AB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 272.605,
    cy: 42.4712,
    r: 4.75,
    transform: "rotate(10.4316 272.605 42.4712)",
    fill: "#8896AB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332.651,
    cy: 69.7947,
    r: 4.75,
    transform: "rotate(10.4316 332.651 69.7947)",
    fill: "#8896AB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.702,
    cy: 89.0525,
    r: 4.75,
    transform: "rotate(10.4316 304.702 89.0525)",
    fill: "#8896AB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274.679,
    cy: 75.3909,
    r: 4.75,
    transform: "rotate(10.4316 274.679 75.3909)",
    fill: "#8896AB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1034_82469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNotFound);
export default __webpack_public_path__ + "static/media/pageNotFound.4a4cd527f7fe286c87992c6fc561a3d8.svg";
export { ForwardRef as ReactComponent };